export const moduleName = {
  promoCode: "Promo Offer",
  collectionInvoice: "Collection Invoice",
  mgmList: "MGM List",
  fishJackpot: "Fish Jackpot",
  buyBonusList: "Buy Bonus List",
  subscription: "Subscription",
  scratchEvent: "Scratch Event",
  couponCode: "Coupon Code",
  loginHistory: "Login History"
};
